import Banner from "../../../../../ui/Banner/Banner";
import Button from "../../../../../ui/Button/Button";
import styles from "./GeneratingBanner.module.scss";
import { useDisclosure } from "../../../../../ui/util/useDisclosure";
import CancelArticleGenerationModal from "../CancelArticleGenerationModal";

function GeneratingBanner({ id }: { id: string }) {
  const [cancelArticleGenerationModalOpened, cancelArticleGeneration] =
    useDisclosure();

  return (
    <Banner className={styles.banner}>
      <div className={styles.bannerContent}>
        <span>
          Please wait until this article has finished generating to edit details
        </span>
        <Button
          variant="outline"
          size="small"
          className={styles.bannerButton}
          onClick={cancelArticleGeneration.open}
        >
          Cancel generation
        </Button>
      </div>

      <CancelArticleGenerationModal
        id={id}
        onClose={cancelArticleGeneration.close}
        isOpen={cancelArticleGenerationModalOpened}
      />
    </Banner>
  );
}

export default GeneratingBanner;
